module.exports = __webpack_public_path__ + "media/images/article/2021_10-8fb3ba80be08966e0122147e0d81a7e5.png";